<template>
  <div>
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <!-- User Info: Input Fields -->
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <!-- Field: Cliente -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('AppVendor.columns.customer')"
              rules="required"
            >
              <b-form-group
                :label="$t('AppVendor.columns.customer')"
                :state="errors.length > 0 ? false:null"
              >
                <v-select
                  v-model="vendorEditData.clienteId"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :clearable="false"
                  label="texto"
                  :options="customers"
                  :reduce="option => option.id"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Field: Alias -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="validationContext"
              :name="$t('AppVendor.columns.nickname')"
              rules="required|max:10"
            >
              <b-form-group
                :label="$t('AppVendor.columns.nickname')"
                label-for="alias"
              >
                <b-form-input
                  id="alias"
                  v-model="vendorEditData.alias"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Field: Nombre -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="validationContext"
              :name="$t('AppVendor.columns.name')"
              rules="required|max:150"
            >
              <b-form-group
                :label="$t('AppVendor.columns.name')"
                label-for="nombre"
              >
                <b-form-input
                  id="nombre"
                  v-model="vendorEditData.nombre"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Field: Rfc -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="validationContext"
              :name="$t('AppVendor.columns.rfc')"
              rules="required|max:13|min:12"
            >
              <b-form-group
                :label="$t('AppVendor.columns.rfc')"
                label-for="rfc"
              >
                <b-form-input
                  id="rfc"
                  v-model="vendorEditData.rfc"
                  :state="getValidationState(validationContext)"
                  onkeyup="this.value = this.value.toUpperCase();"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Field: Domicilio -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="validationContext"
              :name="$t('AppVendor.columns.address')"
              rules="required|max:250"
            >
              <b-form-group
                :label="$t('AppVendor.columns.address')"
                label-for="domicilio"
              >
                <b-form-input
                  id="domicilio"
                  v-model="vendorEditData.domicilio"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

        </b-row>
        <!-- Action Buttons -->
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          type="submit"
        >
          {{ $t('Lists.saveChanges') }}
        </b-button>
        <b-button
          variant="outline-secondary"
          type="reset"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        >
          {{ $t('Lists.reset') }}
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BButton, BRow, BCol, BFormGroup, BFormInput, BForm, BFormInvalidFeedback,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import router from '@/router'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import {
  required, alphaNum, email, min, max,
} from '@validations'
import { ref } from '@vue/composition-api'
import optionsService from '@/services/option.service'
import vendorService from '@/services/vendor.service'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormInvalidFeedback,

    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,

  },
  props: {
    vendorData: {
      type: Object,
      required: true,
    },
  },
  data(props) {
    return {
      required,
      alphaNum,
      email,
      min,
      max,

      descriptionLimit: 60,
      customers: [{ clienteId: props.vendorData.clienteId, nombre: props.vendorData.clienteNombre }],
      isLoading: false,
      selectedCustomer: null,
      search: null,
    }
  },
  setup(props) {
    /* Services */
    const {
      updateVendor,
    } = vendorService()
    const vendorEditData = ref(JSON.parse(JSON.stringify(props.vendorData)))

    const resetvendorEditData = () => {
      vendorEditData.value = JSON.parse(JSON.stringify(props.vendorData))
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetvendorEditData)

    const onSubmit = () => {
      updateVendor(vendorEditData.value)
        .then(() => {
          router.push({ name: 'apps-vendors-list' })
        })
    }

    const customers = ref([])

    const { fetchCustomers } = optionsService()
    fetchCustomers(data => {
      customers.value = data

      if (customers.value.length === 1) {
        vendorEditData.value.clienteId = customers.value[0].id
      }
    })

    return {
      onSubmit,

      // Validation
      refFormObserver,
      getValidationState,
      resetForm,

      vendorEditData,
      customers,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
